module.exports = __webpack_public_path__ + "img/daily_necessities_sanitary.65c9669f.jpg";